<div
  class="dropdown d-block"
  display="dynamic"
  [container]="'body'"
  ngbDropdown
>
  <a
    style="grid-auto-flow: column"
    type="button"
    class="d-grid align-items-center p-0 text-decoration-none"
    ngbDropdownToggle
    id="page-header-user-dropdown"
  >
    <span class="icon-box me-1">
      <span class="isax isax-user text-primary fs-5"> </span>
    </span>
    <div
      class="d-none text-truncate text d-xl-inline-block small ms-1"
      [ngClass]="{ 'text-white': light }"
    >
      <p class="text-truncate text-body lh-1 mb-0">
        {{ acc?.full_name || acc?.username || 'Super Admin' }}
      </p>
      <p class="text-truncate text-gray-700 mb-0 fs-0_75rem">
        {{ displayRole }}
      </p>
    </div>
    <i class="text-body ms-2 radix-caret-down d-none d-xl-inline-block"></i>
  </a>
  <div class="dropdown-menu dropdown-menu-end shadow-sm" ngbDropdownMenu>
    <a
      class="dropdown-item pointer d-flex align-items-center gap-2"
      routerLink="/settings/security"
    >
      <i class="bx bx-shield-quarter align-middle fs-5 text-primary"></i>
      <span>{{ 'SUPER_ADMIN.SECURITY.TITLE' | translate }}</span>
    </a>
    <div class="dropdown-divider"></div>
    <a
      class="dropdown-item text-danger pointer d-flex align-items-center gap-2"
      (click)="logout()"
    >
      <i class="bx bx-power-off align-middle fs-5 text-danger"></i>
      <span>{{ 'COMMON.LOGOUT' | translate }}</span>
    </a>
  </div>
</div>
